import { PlaceholderPage } from './PlaceholderPage'

export default function Settings() {
  return <PlaceholderPage title="Settings" route="/settings" />
}
